module.exports = __webpack_public_path__ + "media/images/stock_groups/e86e-5b6b26727e9e9875c78b96b9c5220d1f.svg";